import { settingsThArray } from '../../../../../../../utils/constants/th_arrays';
import { Table } from '../../../../../../../components/Table/Table';
import React, { useState } from 'react';
import { useGetDevicesQuery } from '../../../../../../../redux/services/DevicesApi';
import { Loading } from '../../../../../../../components/Loading/Loading';
import Status from '../components/Status/Status';
import DeviceName from '../components/DeviceName/DeviceName';
import Actions from '../components/Actions/Actions';
import { Pagination } from '../../../../../../../components/Pagination/Pagination';
import styles from './styles.module.css';

const SettingsTable = () => {
  const [page, setPage] = useState<number>(1);
  const [pageSize] = useState<number>(7);
  const { data: devices, isLoading: isDevicesLoading } = useGetDevicesQuery(
    { page, page_size: pageSize },
    {
      refetchOnMountOrArgChange: true,
    },
  );
  if (isDevicesLoading) {
    return <Loading />;
  }
  return (
    <div className={styles.tableWrapper}>
      <Table
        tableId='trader-settings'
        thArray={settingsThArray}
        tdArray={
          devices?.results?.map((device) => {
            return [
              {
                element: (
                  <DeviceName name={device.name} date={device.create_dt} model={device.model} />
                ),
                style: { width: '20%' },
              },
              { element: device.id, style: { width: '20%' } },
              { element: device.app_version, style: { width: '20%' } },
              { element: <Status status={device.is_online} />, style: { width: '20%' } },
              { element: <Actions deviceId={device.id} />, style: { width: '20%' } },
            ];
          }) || []
        }
      >
        {' '}
      </Table>
      <Pagination
        totalPages={Math.ceil((devices?.count || 0) / pageSize)}
        setCurrentPage={setPage}
        currentPage={page}
        nextPage={devices?.next || page}
        previousPage={devices?.previous || page}
      />
    </div>
  );
};

export default SettingsTable;
